export const MAX_CARDS_TO_SHOW = 10;
